import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = {
    frame: String
  }
  visit(event) {
    const url = event.target.value
    if (url) {
      visit(url, { frame: this.frameValue  })
    }
  }
}